const swagger = {
    invalid_zod_type: 'Zod ประเภทไม่ถูกต้อง กรุณาตรวจสอบการตั้งค่า route guard',
    not_supported_zod_type_for_params: 'ไม่รองรับประเภท Zod สำหรับพารามิเตอร์ กรุณาตรวจสอบการตั้งค่า route guard',
};
export default Object.freeze(swagger);
